import React from "react";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import {
  HvGlobalActions,
  HvTypography,
  HvInput,
  HvTextArea,
  HvGrid,
} from "@hitachivantara/uikit-react-core";

import useStyles from "./styles";

const SopAddEditDetails: React.FC = () => {
  const { t } = useTranslation("sopAddEdit");
  const classes = useStyles();

  const {
    values,
    setFieldTouched,
    setFieldValue,
    status,
    setStatus,
    errors,
    touched,
  } = useFormikContext<SopFormData>();
  const { serverSideErrors = {} } = status;

  const parseStatus = (field: keyof SopFormData) =>
    serverSideErrors[field] || (errors[field] && touched[field])
      ? "invalid"
      : "valid";

  const parseStatusMessage = (field: keyof SopFormData) => {
    if (serverSideErrors[field]) {
      return serverSideErrors[field];
    }

    return errors[field] && touched[field] ? errors[field] : "";
  };

  const clearServerSideErrors = () => {
    setStatus({});
  };

  return (
    <HvGrid container spacing={2}>
      <HvGrid sm={12} item>
        <HvGlobalActions title={t("details.title")} variant="section" />
        <HvTypography variant="normalText">
          {t("details.description")}
        </HvTypography>
      </HvGrid>
      <HvGrid xs={12} md={6} item>
        <HvInput
          className={classes.input}
          name="name"
          label={t("details.fields.name")}
          placeholder={t("details.fields.namePlaceholder")}
          inputProps={{
            autoComplete: "off",
          }}
          required
          value={values.name}
          status={parseStatus("name")}
          statusMessage={parseStatusMessage("name")}
          onBlur={() => {
            setFieldTouched("name");
          }}
          onChange={(evt, value) => {
            setFieldValue("name", value);
            clearServerSideErrors();
          }}
        />
      </HvGrid>
      <HvGrid xs={12} md={8} item>
        <HvTextArea
          className={classes.textarea}
          classes={{
            input: classes.textAreaInput,
          }}
          name="description"
          label={t("details.fields.description")}
          placeholder={t("details.fields.descriptionPlaceholder")}
          rows={5}
          required
          value={values.description}
          status={parseStatus("description")}
          statusMessage={parseStatusMessage("description")}
          onBlur={() => {
            setFieldTouched("description");
          }}
          onChange={(evt, value) => {
            setFieldValue("description", value);
            clearServerSideErrors();
          }}
        />
      </HvGrid>
    </HvGrid>
  );
};

export default SopAddEditDetails;
